function postaviStatuse(cmbId, statusi, prikaziSveStatuse) {
	for (var i = 0; i < statusi.FCount; ++i) {
		var status = statusi.FItems[i].fields;
		if (!prikaziSveStatuse && status.FId == -1)
			continue;
		$("#" + cmbId).append("<option value=\"" + status.FId + "\">" + status.FNaziv + "</option>");
	}
}

// Deprecated: koristiti VpStatusi
function getStatusIzOpcija(opcije) {
	var status = 0;
	var matches = opcije.match(/\d+/);
	if (matches != null && matches.length > 0)
		status = parseInt(matches[0], 10);
	return status;
}

function provjeriDZaglavZakljucan(url, onNezakljucan) {
	$.ajax({
		url: url,
		dataType: "JSON",
		success: function(data, textStatus, jqXHR) {
			if (data == true) {
				prikaziZakljucanDialog();
			}
			else {
				onNezakljucan();	
			}
		}	
	});	
}

function provjeriRacunZakljucan(url, onNezakljucan, onZakljucan) {
	$.dsJSON({
		url: url,
		done: function (data) { 
			if (data === false) {
				if (onNezakljucan) onNezakljucan();
			}
			else if (data === true) {
				if (onZakljucan) onZakljucan();
			}
		}
	});
	/*
	$.ajax({
		url: url,
		dataType: "JSON"
	})
		.done(function (data, textStatus, jqXHR) {
			if (data == true)
				prikaziZakljucanDialog();
			else
				onNezakljucan();
		});
	*/
}

function provjeriKZaglavZakljucan(url, onNezakljucan) {
	$.ajax({
		url: url,
		dataType: "JSON",
		success: function(data, textStatus, jqXHR) {
			if (data == true) {
				prikaziZakljucanDialog();
			} else {
				onNezakljucan();
			}
		}
	});
}

function prikaziZakljucanDialog() {
	var dlgZakljucan = $("<div id=\"dlg-zakljucan\">Dokument je zaključan i ne može se mijenjati.</div>");
	dlgZakljucan.dialog({
		modal: true,
		title: "Upozorenje",
		buttons: {
			"U redu": function() { $(this).dialog("close"); }
		}
	});
}